import * as React from 'react';
const Like = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#4FAB8C"
      fillRule="evenodd"
      d="M11.912 7.286c.25-.34.388-.755.388-1.189a2 2 0 0 0-.974-1.698.986.986 0 0 0-.51-.142H7.25l.09-1.879a1.663 1.663 0 0 0-.44-1.214A1.565 1.565 0 0 0 5.74.654a1.738 1.738 0 0 0-1.663 1.3L2.8 6.71H.876a.47.47 0 0 0-.337.143.496.496 0 0 0-.14.347v5.565c0 .27.213.49.477.49H9.82c.138 0 .271-.03.395-.083.899-.392 1.366-1.416 1.084-2.377.37-.5.484-1.151.309-1.753a2.009 2.009 0 0 0 .304-1.755ZM1.471 12.152V7.81h1.205v4.342H1.47Zm9.467-5.397-.325.29.206.39a.89.89 0 0 1-.19 1.074l-.324.29.206.389a.89.89 0 0 1-.19 1.074l-.325.29.207.39a.89.89 0 0 1 .059.694.86.86 0 0 1-.457.515H3.628v-4.39l1.48-5.51a.66.66 0 0 1 .628-.495.521.521 0 0 1 .385.168c.1.107.153.253.146.402l-.143 3.033H10.8a.889.889 0 0 1 .428.74.888.888 0 0 1-.291.657Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Like;
